import React from 'react'
import SDP from "../animation/about/Creative.json"
import CST from "../animation/about/Newspaper.json"
import DDD from "../animation/about/Data.json"
import ATE from "../animation/about/Trophy.json"
import CE from "../animation/about/Money.json"
import CBE from "../animation/about/Winner.json"
import Lottie from 'lottie-react'


const TailorMadeCard = ({ data }) => (
    <div className="relative space-y-2 w-full text-center">
        <div className=" rounded-full flex items-center justify-center ">
            <Lottie
                animationData={data.src}
                loop={true}
                autoplay={true}
                style={{ width: 100 }}
            // className={marginClass}
            />
        </div>
        <div className="text-xl font-bold dark:text-white ">{data.heading}</div>
        <p className="dark:text-gray-300 text-zinc-800 w-[100%] text-md">
            {data.p}
        </p>
    </div>
);

const data = [
    {
        src: SDP,
        heading: " Strategic Digital Presence",
        p: " Just as an architect lays down blueprints before building a landmark, a digital marketing agency maps out your brand’s online ecosystem. They align strategy with business goals so every click, post, and ad feels intentional."
    },
    {
        src: CST,
        heading: "Creative Storytelling",
        p: "The best branding agency don’t just design they narrate. Through visuals, copy and campaigns, they weave stories that make brands memorable, much like how Apple transformed technology into a lifestyle."
    },
    {
        src: DDD,
        heading: "Data-Driven Decisions",
        p: "No guesswork here. Agencies use analytics, insights and performance metrics to ensure campaigns are efficient and outcomes are measurable very much like Bezos in their precision for the content production services."
    },
    {
        src: ATE,
        heading: "Access to Expertise",
        p: " Why hire one marketer when you can have a team of SEO specialists, designers, media buyers, and strategists working in harmony? It’s like having your own Avengers squad for becoming a successful branding agency."
    },
    {
        src: CE,
        heading: "Cost-Effective Scalability",
        p: "A digital marketing agency allows you to scale marketing efforts without the overhead of building a full in-house team giving you flexibility to adapt to market shifts, just like Netflix pivoted from DVDs to streaming."
    },
    {
        src: CBE,
        heading: "Consistent Brand Experience",
        p: "From social media to web design, a digital marketing agency ensures your brand voice remains consistent across all platforms because in the digital world, consistency builds trust and trust builds empires."
    },
]


const AboutExtraSection1 = () => {
    return (
        <div className='w-full xl:px-35 px-10 py-5 pt-20 pb-10 dark:bg-zinc-900 bg-white space-y-10 '>
            <div className='space-y-7'>
                <h1 className="xl:text-5xl text-4xl font-bold mt-2 tracking-tighter text-center dark:text-white">
                    Transforming Digital Interactions Into Business Success
                </h1>

                <h3 className='dark:text-gray-300 text-zinc-800 text-center text-md'>In today’s hyper-digital world, who wouldn’t want a creative powerhouse as their extended team — one that fuses data, design, and strategy into business results? <br /> That’s exactly what a digital marketing agency brings to the table. Whether it’s shaping brand identity, running high-performing ad campaigns, or building tech-driven <br /> experiences, a top agency can be the spark behind your growth story. Here’s how:
                </h3>
            </div>

            <div className='w-[100%] grid xl:grid-cols-3 gap-10'>
                {
                    data.map((item, index) => (
                        <>
                            <TailorMadeCard data={item} />
                        </>
                    ))
                }
            </div>
        </div>
    )
}

export default AboutExtraSection1